/* Hält Bundle-Geschenke im Warenkorb passend zur Set-Anzahl: entfernt sie, wenn Sets fehlen, und legt sie nach, wenn eine neue Kaching-Stufe erreicht wird (LimeAds) */
(() => {
  if (window.poGiftGuard) return;
  window.poGiftGuard = true;
  let busy = false;

  const isGift = (item) => item.properties && item.properties._po_gift;
  const kachingProps = (item) => {
    try {
      return item.properties && item.properties.__kaching_bundles ? JSON.parse(item.properties.__kaching_bundles) : null;
    } catch (e) {
      return null;
    }
  };

  // Geschenke, die nicht mehr passen oder trotzdem etwas kosten
  const removals = (cart) => {
    const updates = {};
    cart.items.filter(isGift).forEach((gift) => {
      const need = parseInt(gift.properties._po_gift, 10) || 1;
      const forId = parseInt(gift.properties._po_for, 10);
      const have = cart.items
        .filter((item) => !isGift(item) && item.product_id === forId)
        .reduce((sum, item) => sum + item.quantity, 0);
      // Ein Kaching-Geschenk, das trotzdem etwas kostet, gehört nicht in den Warenkorb
      const charged = gift.properties.__kaching_bundles && gift.final_line_price > 0;
      if (have < need || charged) updates[gift.key] = 0;
      else if (gift.quantity > 1) updates[gift.key] = 1;
    });
    return updates;
  };

  // Fehlende Geschenke nur nachlegen, wenn die Set-Anzahl gestiegen ist (ein bewusst gelöschtes Geschenk kommt nicht ungefragt zurück)
  const additions = async (cart) => {
    if (!window.poKaching) return [];
    const groups = {};
    cart.items.forEach((item) => {
      const props = kachingProps(item);
      if (!props || !props.main || isGift(item)) return;
      const group = groups[props.id] || (groups[props.id] = { productId: item.product_id, handle: item.handle, quantity: 0 });
      group.quantity += item.quantity;
    });
    let seen = {};
    try {
      seen = JSON.parse(sessionStorage.getItem('poGiftSeen') || '{}');
    } catch (e) {
      seen = {};
    }
    const items = [];
    for (const [id, group] of Object.entries(groups)) {
      const before = seen[id] || 0;
      seen[id] = group.quantity;
      if (group.quantity <= before) continue;
      const deal = await window.poKaching.dealForHandle(group.handle, group.productId).catch(() => null);
      if (deal) items.push(...(await window.poKaching.lines(deal, cart, group.productId, [], true)));
    }
    try {
      sessionStorage.setItem('poGiftSeen', JSON.stringify(seen));
    } catch (e) {
      /* ohne Speicher: dann eben bei jeder Erhöhung prüfen */
    }
    return items;
  };

  const render = (drawer, res) => {
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
    } else if (drawer && res.sections && typeof drawer.renderContents === 'function') {
      drawer.renderContents(res);
      // Das Theme rendert den Drawer manchmal kurz danach noch einmal mit altem Stand
      setTimeout(async () => {
        if (!drawer.classList.contains('active')) return;
        const ids = drawer.getSectionsToRender().map((s) => s.id).join(',');
        const sections = await fetch(`${window.location.pathname}?sections=${ids}`).then((r) => r.json());
        drawer.renderContents({ sections });
      }, 900);
    }
  };

  const check = async () => {
    if (busy) return;
    busy = true;
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      const drawer = document.querySelector('cart-drawer');
      const sectionParams = {};
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        sectionParams.sections = drawer.getSectionsToRender().map((s) => s.id);
        sectionParams.sections_url = window.location.pathname;
      }

      const updates = removals(cart);
      if (Object.keys(updates).length) {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates, ...sectionParams })
        }).then((r) => r.json());
        render(drawer, res);
        return;
      }

      const items = await additions(cart);
      if (!items.length) return;
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, ...sectionParams })
      }).then((r) => r.json());
      if (!res.status) render(drawer, res);
    } catch (e) {
      /* still: Warenkorb bleibt wie er ist */
    } finally {
      busy = false;
    }
  };

  if (typeof window.subscribe === 'function') window.subscribe('cart-update', () => setTimeout(check, 500));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
  else check();
})();
